<template>
  <header itemscope itemtype="https://schema.org/WPHeader">
    <div class="container">
      <nav itemscope itemtype="https://schema.org/SiteNavigationElement" aria-label="Main navigation">
        <a href="/home.html" class="logo" itemscope itemtype="https://schema.org/Organization">
          <meta itemprop="url" content="https://customteamkit.com">
          <img src="/logo.png" alt="Custom Team Kit - Custom Team Apparel Manufacturer" 
               width="120" height="30" itemprop="logo"
               loading="eager" fetchpriority="high">
          <div class="logo-text-group">
            <span class="logo-name" itemprop="name">3D Online Designer</span>
            <span class="logo-tagline">Create Your Custom Team Kit in Minutes</span>
          </div>
        </a>

        <ul class="nav-links" id="navLinks">
          <li><a href="/home.html" itemprop="url">Home</a></li>
          <li><a href="/index.html" itemprop="url"><strong>3D Designer</strong></a></li>
          <li><a href="/home.html#HOWTO" itemprop="url">How it Works</a></li>
          <li><a href="/home.html#CONTACT" itemprop="url">Contact</a></li>
        </ul>

        <button 
          class="burger-btn" 
          :class="{ 'open': isMenuOpen }" 
          @click="toggleMenu" 
          aria-label="Open menu" 
          :aria-expanded="isMenuOpen.toString()"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>

      <div 
        class="mobile-menu" 
        :class="{ 'open': isMenuOpen }" 
        :aria-hidden="(!isMenuOpen).toString()"
      >
        <ul>
          <li><a href="/home.html" @click="closeMobileMenu">Home</a></li>
          <li><a href="/index.html" @click="closeMobileMenu">3D Designer</a></li>
          <li><a href="/home.html#HOWTO" @click="closeMobileMenu">How it Works</a></li>
          <li><a href="/home.html#CONTACT" @click="closeMobileMenu">Contact</a></li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref } from 'vue'

// 响应式状态控制移动端菜单的打开/关闭
const isMenuOpen = ref(false)

// 切换菜单状态
const toggleMenu = (event) => {
  event.stopPropagation() // 阻止冒泡，防御外部点击干扰
  isMenuOpen.value = !isMenuOpen.value
}

// 点击任意链接后自动收回菜单
const closeMobileMenu = () => {
  isMenuOpen.value = false
}
</script>

<style scoped>
/* 使用 scoped 确保样式完美隔离，绝不污染 3D 衣服定制画布 */

/* ── Header 基础布局 ── */
header {
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  position: relative;
  top: 0;
  width: 100%;
  z-index: 99999 !important; /* 核心修正：层级提到最高，绝对压在 3D 定制区域之上 */
}

header .container {
  width: 90%;
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
}

nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px; /* 扩展高度，利于移动端手指触控 */
}

/* ── Logo 样式 ── */
.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  flex-shrink: 0;
}

.logo img {
  height: 30px;
  width: auto;
  display: block;
}

.logo-text-group {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  max-height: 35px;
  overflow: hidden;
}

.logo-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: #111111;
  letter-spacing: -0.2px;
  font-family: 'Inter', sans-serif;
}

.logo-tagline {
  font-size: 0.68rem;
  color: #6b7280;
  font-weight: 400;
  letter-spacing: 0.1px;
  font-family: 'Inter', sans-serif;
  line-height: 1;
}

/* ── 桌面端导航链接 ── */
.nav-links {
  display: flex;
  list-style: none;
  align-items: center;
  gap: 2rem;
  margin: 0;
  padding: 0;
}

.nav-links a {
  text-decoration: none;
  color: #374151;
  font-weight: 500;
  font-size: 0.9rem;
  font-family: 'Inter', sans-serif;
  transition: color 0.2s ease;
  white-space: nowrap;
}

.nav-links a:hover {
  color: #111111;
}

/* ── 移动端汉堡按钮 ── */
.burger-btn {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px; /* 增大移动端热区，更容易点中 */
  border-radius: 4px;
  outline: none;
  -webkit-tap-highlight-color: transparent; /* 清除手机端点击瞬间产生的蓝色高亮框 */
}

.burger-btn span {
  display: block;
  width: 22px;
  height: 2px;
  background: #111111;
  border-radius: 1px;
  transition: transform 0.25s ease, opacity 0.25s ease;
}

/* 汉堡按钮变成高级 X 变形动画 */
.burger-btn.open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}
.burger-btn.open span:nth-child(2) {
  opacity: 0;
}
.burger-btn.open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* ── 核心修正：移动端绝对悬浮下拉菜单 ── */
.mobile-menu {
  display: none;
  position: absolute;   
  top: 100%;            /* 紧贴在 header 的正下方外沿 */
  left: 0;
  width: 100%;
  background: #ffffff;  
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  padding: 0.5rem 5% 1rem;
  box-shadow: 0 8px 16px rgba(0,0,0,0.1); /* 高级悬浮阴影 */
  z-index: 999999 !important;
}

/* 当 Vue 给它打上 open 标签时，强制块级展现 */
.mobile-menu.open {
  display: block !important;
}

.mobile-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.mobile-menu ul li a {
  display: block;
  padding: 0.8rem 0;
  color: #374151;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  border-bottom: 1px solid #f3f4f6;
}

.mobile-menu ul li a:hover {
  color: #111111;
}

/* ── 响应式断点 ── */
@media (max-width: 768px) {
  .nav-links {
    display: none;
  }
  .burger-btn {
    display: flex;
  }
  .logo-name {
    font-size: 0.85rem;
  }
  .header {
        position: relative;  /* 确保移动端也是相对定位 */
    }
}

@media (max-width: 480px) {
  header .container {
    width: 92%;
  }
  .logo-name {
    font-size: 0.8rem;
  }
    .header {
        position: relative;  /* 确保移动端也是相对定位 */
    }
}
</style>